import React, {useEffect, useState} from 'react'
import {Card,CardHeader,CardBody, Box,Text,Layer,Spinner,Button, CardFooter,Tag } from 'grommet'
import {Launch,User,Organization,Plan, Table,Package,TestDesktop, Deliver, LineChart} from 'grommet-icons';
import { withRouter } from 'react-router-dom';
import { API,Auth } from 'aws-amplify';

function MainCardBody(props){
    const data = props.data
    return (
        <CardBody direction='row' style={{justifyContent: 'space-between', minWidth: 450, minHeight:80}}>
                {(data.data ? 
                <Box>
                    <Text style={{marginTop:30}} size='large'>{data.value}</Text>
                    <Text size='medium' margin='small'>{data.subheading}</Text>
                    <Box direction="row" justify="end"><Box direction="row"><Tag margin='xsmall' background='status-disabled' size='small' name="Awaiting Pickup" value={`${data.data.awaitingPickup}`} /><Tag margin='xsmall' background='status-ok' size='small' name="In Transit" value={`${data.data.inTransit}`} /><Tag margin='xsmall' background='status-warning' size='small' name="Exception" value={`${data.data.exception}`} /></Box></Box>
                </Box>
                : null )}
        </CardBody>
    )
}
function DashboardCards (props) {
    const [showQuote, setShowQuote] = useState(false)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [dashboardTopCards, setDashboardTopCards] = useState([])
    const [dashboardSecondaryCards, setDashboardSecondaryCards] = useState([])
    const [dashboardThirdRowCards, setDashboardThirdRowCards] = useState([])
      useEffect(() => {     
        if (props.user === 'SuperAdmin'){
            Auth.currentSession().then(session => {
                API
                    .get("LabShip", '/dashboard/admin',{headers: { 
                    Authorization: session.idToken.jwtToken,
                    }})
                    .then(
                    (result) => {
                        setDashboardTopCards([{buttonLabel: 'Create Shipment',color: 'light-4', heading: 'Create Shipment', icon: <Launch size='medium'color='brand'/>,buttonIcon: <Launch size='medium'/>,link: '/shipment/new' },{buttonLabel: "View All Shipments", data:{awaitingPickup: result.awaitingPickup, inTransit: result.inTransit, exception:result.exception}, color: 'light-4',heading: 'All Shipments',  subheading:'Overview', icon: <Table size='medium' color='brand' />, buttonIcon: <Table size='medium'/>, link: '/admin/shipments/all'},{buttonLabel: 'Quick Quote', buttonIcon:<Plan size='medium'/> ,color: 'light-4', heading: 'Quick Quote', icon: <Plan size='medium'color='brand'/>,link: '/quote/new'}]);
                        setDashboardSecondaryCards([{buttonLabel: 'Manage Organisations', buttonIcon: <Organization size='medium'/>,color: 'light-4',heading: 'Organisation Management', icon: <Organization size='medium' color='brand'/>, link: '/admin/organisations/all'},{buttonLabel: 'Manage Labs', buttonIcon: <TestDesktop size='medium'/>, color: 'light-4',heading: 'Lab Management', icon: <TestDesktop size='medium' color='brand'/>, link: '/admin/labs/all'},{buttonLabel: "Manage Customers", buttonIcon:  <Organization size='medium'/>, color: 'light-4',heading: 'Customer Management', icon: <Organization size='medium' color='brand'/>, link: '/admin/customers/all'}])
                        setDashboardThirdRowCards([{buttonLabel: 'View Reports', buttonIcon:<LineChart size='medium'/>, color: 'light-4', heading: 'Invoicing and Reporting', icon: <LineChart size='medium'color='brand'/>,link: '/admin/billing/all'},{buttonLabel: 'Manage Users', buttonIcon:  <User size='medium'/>, color: 'light-4',heading: 'User Management', icon: <User size='medium' color='brand'/>, link: '/admin/users/all'},{buttonLabel: 'Manage Commodities', buttonIcon: <Package size='medium'/>, color: 'light-4',heading: 'Commodities Management', icon: <Package size='medium' color='brand'/>, link: '/admin/commodities/all'}])
                        setDataLoaded(true);
                    },
                    (error) => {
                        console.log(error);
                    }
                    );
                })
        } else if (props.user === 'Lab') {
            Auth.currentSession().then(session => {
                API
                    .get("LabShip", '/dashboard/lab',{headers: { 
                    Authorization: session.idToken.jwtToken,
                    }})
                    .then(
                        (result) => {
                            setShowQuote(result.displayQuote)
                            if (result.displayQuote){
                                setDashboardTopCards([{buttonLabel: "View All Shipments", data:{awaitingPickup: result.awaitingPickup, inTransit: result.inTransit, exception:result.exception}, color: 'light-4',heading: 'All Shipments',  subheading:'Overview', icon: <Table size='medium' color='brand' />, buttonIcon: <Table size='medium'/>, link: '/shipments/all'},{buttonLabel: 'Create Shipment',color: 'light-4', heading: 'Create Shipment', icon: <Launch size='medium'color='brand'/>,buttonIcon: <Launch size='medium'/>,link: '/shipment/new' },{buttonLabel: 'Quick Quote', buttonIcon:<Plan size='medium'/>,color: 'light-4', heading: 'Quick Quote', icon: <Plan size='medium'color='brand'/>,link: '/quote/new'}])
                            } else {
                                setDashboardTopCards([{buttonLabel: "View All Shipments", data:{awaitingPickup: result.awaitingPickup, inTransit: result.inTransit, exception:result.exception}, color: 'light-4',heading: 'All Shipments', subheading:'Overview', icon: <Table size='medium' color='brand' />, buttonIcon: <Table size='medium'/>, link: '/shipments/all'},{buttonLabel: 'Create Shipment',color: 'light-4', heading: 'Create Shipment', icon: <Launch size='medium'color='brand'/>, buttonIcon: <Launch size='medium'/>,link: '/shipment/new' }])
                            }
                            setDashboardSecondaryCards([{color: 'light-4',heading: 'User Management', icon: <User size='medium' color='brand'/>, buttonLabel: 'Manage Users',  buttonIcon: <User size='medium' />, link: '/users/all', data: ""},{buttonLabel: 'Manage Customers', buttonIcon: <Organization size='medium' />, color: 'light-4',heading: 'Customer Management', icon: <Organization size='medium' color='brand'/>, link: '/customers/all', data: ""}])
                            setDataLoaded(true)
                        },
                        (error) => {
                          setDataLoaded(true)
                          console.log(error);
                        }
                    );
                })
        } else {
            setDashboardTopCards([{buttonLabel: "View All Shipments", color: 'light-4',heading: 'All Shipments', subheading:'Overview', icon: <Table size='medium' color='brand' />, buttonIcon: <Table size='medium'/>, link: '/shipments/all'},{buttonLabel: 'Create Shipment',color: 'light-4', heading: 'Create Shipment', icon: <Launch size='medium'color='brand'/>, buttonIcon: <Launch size='medium'/>,link: '/shipment/new' }])
            setDataLoaded(true)
        }
       },[]);   
      if (dataLoaded){
          return(
            <Box>
            <Box direction='row' gap='xsmall' justify='center' >
            {dashboardTopCards.map(value => {
                return (
                <Card background={'background-front'} hoverIndicator pad='medium'  rounded elevation='large' margin='small' >
                    <CardHeader>
                        {value.icon}<Text weight='bold' margin='small'>{value.heading}</Text>
                    </CardHeader>
                    <MainCardBody data={value} />
                    <CardFooter margin={{top:'medium'}}>
                        <Button size='small' icon={value.buttonIcon} primary hoverIndicator onClick={() => {props.history.push({pathname: value.link, showQuote: showQuote})}}  label={<Text size='small' weight='bold'>{value.buttonLabel}</Text>}/>
                        {(value.heading.includes("Create Shipment") ? <Button size='small' icon={<Deliver />} primary hoverIndicator onClick={() => {props.history.push({pathname: '/collection/new', showQuote: showQuote})}}  label={<Text size='small' weight='bold'>{'Book Collection'}</Text>}/>: null )}
                    </CardFooter>
                </Card>
                )
            })}
            </Box>
            <Box direction='row' justify='center' gap='xsmall'>
                {dashboardSecondaryCards.map(value => {
                    return (
                         <Card background={'background-front'} hoverIndicator pad='medium'  rounded elevation='large' margin='small' >
                         <CardHeader>
                             {value.icon}<Text weight='bold' margin='small'>{value.heading}</Text>
                         </CardHeader>
                         <MainCardBody data={value} />
                         <CardFooter margin={{top:'medium'}}>
                             <Button size='small' icon={value.buttonIcon} primary hoverIndicator  onClick={() => {props.history.push(value.link)}}  label={<Text size='small' weight='bold'>{value.buttonLabel}</Text>}/>
                         </CardFooter>
                     </Card>
                    )
                })}
            </Box>
            <Box direction='row' justify='center' gap='xsmall'>
                {dashboardThirdRowCards.map(value => {
                    return (
                        <Card background={'background-front'} hoverIndicator pad='medium'  rounded elevation='large' margin='small' >
                        <CardHeader>
                            {value.icon}<Text weight='bold' margin='small'>{value.heading}</Text>
                        </CardHeader>
                        <MainCardBody data={value} />
                        <CardFooter margin={{top:'medium'}}>
                            <Button size='small' icon={value.buttonIcon} primary hoverIndicator  onClick={() => {props.history.push(value.link)}} label={<Text size='small' weight='bold'>{value.buttonLabel}</Text>}/>
                        </CardFooter>
                    </Card>
                    )
                })}
            </Box>
        </Box>
          )
      } else {
        return (
            <Layer>
            <Box align='center' justify='center' margin="medium">
              <Spinner margin='small' size='medium' />
              <Text margin='small'>Loading Dashboard...</Text>
            </Box>
          </Layer>
          )
      }
      
}

export default withRouter(DashboardCards)
